import Parse from 'html-react-parser';

function BMP20205(props) {
    let svgCode =
    `<svg width="656" height="600" viewBox="0 0 656 600" fill="none" xmlns="http://www.w3.org/2000/svg">
    <style type="text/css">
    .styledText text {
        ${props.styledText}
    }
    .boxStyle rect {
        ${props.boxStyle}
    }
    ${props.fontFace}
    </style>
        <g class="boxStyle">
        <g class="styledText" letter-spacing="${props.fontExtras.space}" font-weight="${props.fontExtras.weight}" fill="${props.fontColour}" font-family="${props.fontName}" >
        <rect x="4" y="2" width="316" height="56" rx="6" fill="${props.paramFill}"/>
        <rect x="19" y="19" width="40" height="24" rx="3" fill="${props.darkFill}" stroke="black" stroke-width="2"/>
        <path d="M298 46L304.062 35.5H291.938L298 46Z" fill="${props.fontColour}"/>
        <path d="M298 14L304.062 24.5H291.938L298 14Z" fill="${props.fontColour}"/>
        <path d="M296 36H300V24H296V36Z" fill="${props.fontColour}"/>
        <text font-size="24"><tspan x="83" y="40.2031">DISTORTION</tspan></text>
        <rect x="332" y="2" width="316" height="56" rx="6" fill="${props.paramFill}"/>
        <rect x="347" y="19" width="40" height="24" rx="3" fill="#EA7C05" stroke="black" stroke-width="2" filter="drop-shadow( 0px 0px 8px #EA7C05)" />
        <path d="M626 46L632.062 35.5H619.938L626 46Z" fill="${props.fontColour}"/>
        <path d="M626 14L632.062 24.5H619.938L626 14Z" fill="${props.fontColour}"/>
        <path d="M624 36H628V24H624V36Z" fill="${props.fontColour}"/>
        <text font-size="24"><tspan x="411" y="40.2031">DISTORTION</tspan></text>
        <rect x="4" y="62" width="316" height="56" rx="6" fill="${props.paramFill}"/>
        <rect x="19" y="79" width="40" height="24" rx="3" fill="${props.darkFill}" stroke="black" stroke-width="2"/>
        <path d="M298 106L304.062 95.5H291.938L298 106Z" fill="${props.fontColour}"/>
        <path d="M298 74L304.062 84.5H291.938L298 74Z" fill="${props.fontColour}"/>
        <path d="M296 96H300V84H296V96Z" fill="${props.fontColour}"/>
        <text font-size="24"><tspan x="83" y="100.203">FLANGER</tspan></text>
        <rect x="332" y="62" width="316" height="56" rx="6" fill="${props.paramFill}"/>
        <rect x="347" y="79" width="40" height="24" rx="3" fill="#D54497" stroke="black" stroke-width="2" filter="drop-shadow( 0px 0px 8px #D54497)" />
        <path d="M626 106L632.062 95.5H619.938L626 106Z" fill="${props.fontColour}"/>
        <path d="M626 74L632.062 84.5H619.938L626 74Z" fill="${props.fontColour}"/>
        <path d="M624 96H628V84H624V96Z" fill="${props.fontColour}"/>
        <text font-size="24"><tspan x="411" y="100.203">FLANGER</tspan></text>
        <rect x="4" y="122" width="316" height="56" rx="6" fill="${props.paramFill}"/>
        <rect x="19" y="139" width="40" height="24" rx="3" fill="${props.darkFill}" stroke="black" stroke-width="2"/>
        <path d="M298 166L304.062 155.5H291.938L298 166Z" fill="${props.fontColour}"/>
        <path d="M298 134L304.062 144.5H291.938L298 134Z" fill="${props.fontColour}"/>
        <path d="M296 156H300V144H296V156Z" fill="${props.fontColour}"/>
        <text font-size="24"><tspan x="83" y="160.203">PHASER</tspan></text>
        <rect x="332" y="122" width="316" height="56" rx="6" fill="${props.paramFill}"/>
        <rect x="347" y="139" width="40" height="24" rx="3" fill="#30C175" stroke="black" stroke-width="2" filter="drop-shadow( 0px 0px 8px #30C175)"/>
        <path d="M626 166L632.062 155.5H619.938L626 166Z" fill="${props.fontColour}"/>
        <path d="M626 134L632.062 144.5H619.938L626 134Z" fill="${props.fontColour}"/>
        <path d="M624 156H628V144H624V156Z" fill="${props.fontColour}"/>
        <text font-size="24"><tspan x="411" y="160.203">PHASER</tspan></text>
        <rect x="4" y="182" width="316" height="56" rx="6" fill="${props.paramFill}"/>
        <rect x="19" y="199" width="40" height="24" rx="3" fill="${props.darkFill}" stroke="black" stroke-width="2"/>
        <path d="M298 226L304.062 215.5H291.938L298 226Z" fill="${props.fontColour}"/>
        <path d="M298 194L304.062 204.5H291.938L298 194Z" fill="${props.fontColour}"/>
        <path d="M296 216H300V204H296V216Z" fill="${props.fontColour}"/>
        <text font-size="24"><tspan x="83" y="220.203">CHORUS</tspan></text>
        <rect x="332" y="182" width="316" height="56" rx="6" fill="${props.paramFill}"/>
        <rect x="347" y="199" width="40" height="24" rx="3" fill="#50B1D6" stroke="black" stroke-width="2" filter="drop-shadow( 0px 0px 8px #50B1D6)"/>
        <path d="M626 226L632.062 215.5H619.938L626 226Z" fill="${props.fontColour}"/>
        <path d="M626 194L632.062 204.5H619.938L626 194Z" fill="${props.fontColour}"/>
        <path d="M624 216H628V204H624V216Z" fill="${props.fontColour}"/>
        <text font-size="24"><tspan x="411" y="220.203">CHORUS</tspan></text>
        <rect x="4" y="242" width="316" height="56" rx="6" fill="${props.paramFill}"/>
        <rect x="19" y="259" width="40" height="24" rx="3" fill="${props.darkFill}" stroke="black" stroke-width="2"/>
        <path d="M298 286L304.062 275.5H291.938L298 286Z" fill="${props.fontColour}"/>
        <path d="M298 254L304.062 264.5H291.938L298 254Z" fill="${props.fontColour}"/>
        <path d="M296 276H300V264H296V276Z" fill="${props.fontColour}"/>
        <text font-size="24"><tspan x="83" y="280.203">DELAY</tspan></text>
        <rect x="332" y="242" width="316" height="56" rx="6" fill="${props.paramFill}"/>
        <rect x="347" y="259" width="40" height="24" rx="3" fill="#A26FD6" stroke="black" stroke-width="2" filter="drop-shadow( 0px 0px 8px #A26FD6)"/>
        <path d="M626 286L632.062 275.5H619.938L626 286Z" fill="${props.fontColour}"/>
        <path d="M626 254L632.062 264.5H619.938L626 254Z" fill="${props.fontColour}"/>
        <path d="M624 276H628V264H624V276Z" fill="${props.fontColour}"/>
        <text font-size="24"><tspan x="411" y="280.203">DELAY</tspan></text>
        <rect x="4" y="302" width="316" height="56" rx="6" fill="${props.paramFill}"/>
        <rect x="19" y="319" width="40" height="24" rx="3" fill="${props.darkFill}" stroke="black" stroke-width="2"/>
        <path d="M298 346L304.062 335.5H291.938L298 346Z" fill="${props.fontColour}"/>
        <path d="M298 314L304.062 324.5H291.938L298 314Z" fill="${props.fontColour}"/>
        <path d="M296 336H300V324H296V336Z" fill="${props.fontColour}"/>
        <text font-size="24"><tspan x="83" y="340.203">COMPRESSOR</tspan></text>
        <rect x="332" y="302" width="316" height="56" rx="6" fill="${props.paramFill}"/>
        <rect x="347" y="319" width="40" height="24" rx="3" fill="#A99176" stroke="black" stroke-width="2" filter="drop-shadow( 0px 0px 8px #A99176)"/>
        <path d="M626 346L632.062 335.5H619.938L626 346Z" fill="${props.fontColour}"/>
        <path d="M626 314L632.062 324.5H619.938L626 314Z" fill="${props.fontColour}"/>
        <path d="M624 336H628V324H624V336Z" fill="${props.fontColour}"/>
        <text font-size="24"><tspan x="411" y="340.203">COMPRESSOR</tspan></text>
        <rect x="4" y="362" width="316" height="56" rx="6" fill="${props.paramFill}"/>
        <rect x="19" y="379" width="40" height="24" rx="3" fill="${props.darkFill}" stroke="black" stroke-width="2"/>
        <path d="M298 406L304.062 395.5H291.938L298 406Z" fill="${props.fontColour}"/>
        <path d="M298 374L304.062 384.5H291.938L298 374Z" fill="${props.fontColour}"/>
        <path d="M296 396H300V384H296V396Z" fill="${props.fontColour}"/>
        <text font-size="24"><tspan x="83" y="400.203">REVERB</tspan></text>
        <rect x="332" y="362" width="316" height="56" rx="6" fill="${props.paramFill}"/>
        <rect x="347" y="379" width="40" height="24" rx="3" fill="#7CC20F" stroke="black" stroke-width="2" filter="drop-shadow( 0px 0px 8px #7CC20F)"/>
        <path d="M626 406L632.062 395.5H619.938L626 406Z" fill="${props.fontColour}"/>
        <path d="M626 374L632.062 384.5H619.938L626 374Z" fill="${props.fontColour}"/>
        <path d="M624 396H628V384H624V396Z" fill="${props.fontColour}"/>
        <text font-size="24"><tspan x="411" y="400.203">REVERB</tspan></text>
        <rect x="4" y="422" width="316" height="56" rx="6" fill="${props.paramFill}"/>
        <rect x="19" y="439" width="40" height="24" rx="3" fill="${props.darkFill}" stroke="black" stroke-width="2"/>
        <path d="M298 466L304.062 455.5H291.938L298 466Z" fill="${props.fontColour}"/>
        <path d="M298 434L304.062 444.5H291.938L298 434Z" fill="${props.fontColour}"/>
        <path d="M296 456H300V444H296V456Z" fill="${props.fontColour}"/>
        <text font-size="24"><tspan x="83" y="460.203">EQ</tspan></text>
        <rect x="332" y="422" width="316" height="56" rx="6" fill="${props.paramFill}"/>
        <rect x="347" y="439" width="40" height="24" rx="3" fill="#C6C2BE" stroke="black" stroke-width="2" filter="drop-shadow( 0px 0px 8px #C6C2BE)"/>
        <path d="M626 466L632.062 455.5H619.938L626 466Z" fill="${props.fontColour}"/>
        <path d="M626 434L632.062 444.5H619.938L626 434Z" fill="${props.fontColour}"/>
        <path d="M624 456H628V444H624V456Z" fill="${props.fontColour}"/>
        <text font-size="24"><tspan x="411" y="460.203">EQ</tspan></text>
        <rect x="4" y="482" width="316" height="56" rx="6" fill="${props.paramFill}"/>
        <rect x="19" y="499" width="40" height="24" rx="3" fill="${props.darkFill}" stroke="black" stroke-width="2"/>
        <path d="M298 526L304.062 515.5H291.938L298 526Z" fill="${props.fontColour}"/>
        <path d="M298 494L304.062 504.5H291.938L298 494Z" fill="${props.fontColour}"/>
        <path d="M296 516H300V504H296V516Z" fill="${props.fontColour}"/>
        <text font-size="24"><tspan x="83" y="520.203">FILTER</tspan></text>
        <rect x="332" y="482" width="316" height="56" rx="6" fill="${props.paramFill}"/>
        <rect x="347" y="499" width="40" height="24" rx="3" fill="#0987D6" stroke="black" stroke-width="2" filter="drop-shadow( 0px 0px 8px #0987D6)"/>
        <path d="M626 526L632.062 515.5H619.938L626 526Z" fill="${props.fontColour}"/>
        <path d="M626 494L632.062 504.5H619.938L626 494Z" fill="${props.fontColour}"/>
        <path d="M624 516H628V504H624V516Z" fill="${props.fontColour}"/>
        <text font-size="24"><tspan x="411" y="520.203">FILTER</tspan></text>
        <rect x="4" y="542" width="316" height="56" rx="6" fill="${props.paramFill}"/>
        <rect x="19" y="559" width="40" height="24" rx="3" fill="${props.darkFill}" stroke="black" stroke-width="2"/>
        <path d="M298 586L304.062 575.5H291.938L298 586Z" fill="${props.fontColour}"/>
        <path d="M298 554L304.062 564.5H291.938L298 554Z" fill="${props.fontColour}"/>
        <path d="M296 576H300V564H296V576Z" fill="${props.fontColour}"/>
        <text font-size="24"><tspan x="83" y="580.203">HYPER/DIMENSION</tspan></text>
        <rect x="332" y="542" width="316" height="56" rx="6" fill="${props.paramFill}"/>
        <rect x="347" y="559" width="40" height="24" rx="3" fill="#C0AB0F" stroke="black" stroke-width="2" filter="drop-shadow( 0px 0px 8px #C0AB0F)"/>
        <path d="M626 586L632.062 575.5H619.938L626 586Z" fill="${props.fontColour}"/>
        <path d="M626 554L632.062 564.5H619.938L626 554Z" fill="${props.fontColour}"/>
        <path d="M624 576H628V564H624V576Z" fill="${props.fontColour}"/>
        <text font-size="24"><tspan x="411" y="580.203">HYPER/DIMENSION</tspan></text>
        </g>
        </g>
    </svg>`

    props.svgReturn(85, svgCode, "bmp00205", 656, 600);

    return (
        Parse(svgCode)
    );
}

export default BMP20205;